import * as DropdownPrimitive from "@radix-ui/react-dropdown-menu";

export const DropdownMenu = DropdownPrimitive.Root;
export const DropdownTrigger = DropdownPrimitive.Trigger;
